import React, { FC, memo } from 'react'
import { ListWrapper, FooterGroupList, Slide, Title, FooterList, SeoHref } from './styles'
import FooterSectionTransport from '../../../transports/common/footer-section-transport'

interface FooterLinksContentProps {
    footerGroups: FooterSectionTransport['footerGroups']
}

const FooterLinksContent: FC<FooterLinksContentProps> = ({ footerGroups }) => {
    return (
        <FooterList>
            {footerGroups.map(item => (
                <ListWrapper key={item.groupName}>
                    <FooterGroupList>
                        <li>
                            <Title>{item.groupName}</Title>
                        </li>
                        {item.footerLinkItems.map(footerLinkItem => (
                            <li key={footerLinkItem.text}>
                                <SeoHref
                                    as={Slide}
                                    title={footerLinkItem.text}
                                    href={footerLinkItem.url}
                                    noCrawl={footerLinkItem.noCrawl}
                                >
                                    {footerLinkItem.text}
                                </SeoHref>
                            </li>
                        ))}
                    </FooterGroupList>
                </ListWrapper>
            ))}
        </FooterList>
    )
}

export default memo(FooterLinksContent)
